function startCountdown(expirationDate, elementId) {
    var expiryTimestamp = new Date(expirationDate).getTime();
    var countdownElement = document.getElementById(elementId);
    var interval = setInterval(function() {
        var now = new Date().getTime();
        var distance = expiryTimestamp - now;
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        countdownElement.innerText = days + "d " + hours + "h " + minutes + "m " + seconds + "s ";
        if (distance < 0) {
            clearInterval(interval);
            countdownElement.innerText = "Expired";
        }
    }, 1000);
}

